/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from '~/core'
setup()

// import "~/global/_body";
import '~/global/_flowHeader'
import '~/global/_header'
import '~/global/_footer'
import '~/global/_siteModals'
import '~/global/_wave'

import '~/components/_accordion'
import '~/components/_forms'
import '~/components/_productList'
import '~/components/_specifications'
